export const UserActions = {
  UPDATE_SIGNUP: '@UserActions/UPDATE_SIGNUP',
  SET_TRAINERS: '@UserActions/SET_TRAINERS',
};

const userState = {
  userSignUp: {
    group_qnt: 1,
    id_plano: '',
    nome: '',
    cpf: '',
    telefone: '',
    email: '',
    senha: '',
    objetivo1: null,
    objetivo2: null,
    objetivo3: null,
    id_profissional: '',
    segunda: 0,
    terca: 0,
    quarta: 0,
    quinta: 0,
    sexta: 0,
    sabado: 0,
    domingo: 0,
    horario: '',
    forma_pagamento: '',
    nome2: null,
    nome3: null,
    nome4: null,
    email2: null,
    email3: null,
    email4: null,
  },
  trainerList: [],
};

const userStateReset = {
  userSignUp: {
    group_qnt: 1,
    id_plano: '',
    nome: '',
    cpf: '',
    telefone: '',
    email: '',
    senha: '',
    objetivo1: null,
    objetivo2: null,
    objetivo3: null,
    id_profissional: '',
    segunda: 0,
    terca: 0,
    quarta: 0,
    quinta: 0,
    sexta: 0,
    sabado: 0,
    domingo: 0,
    horario: '',
    forma_pagamento: '',
    nome2: null,
    nome3: null,
    nome4: null,
    email2: null,
    email3: null,
    email4: null,
  },
  trainerList: [],
};
const UserReducer = (state = userState, action) => {
  switch (action.type) {
    case UserActions.UPDATE_SIGNUP: return { ...state, userSignUp: action.userSignUp };
    case UserActions.SET_TRAINERS: return { ...state, trainerList: action.trainerList };
    default: return { ...state };
  }
};

export default UserReducer;
export { userStateReset };
